import { BookOutlined, CheckCircleOutlined, FileProtectOutlined } from "@ant-design/icons";
import { Badge, Typography } from "antd";

const AboutTab = ({ items = [], tags = [] }) => {

console.log(7,items);
    return (<div className="flex flex-col gap-12">

        <div className="">
            <Typography.Title level={4}>What you'll learn</Typography.Title >

            <ul style={{ listStyle: 'none', padding: 0, lineHeight: '1.8' }}>
                {items.map((item, index) => (
                    <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                        <CheckCircleOutlined style={{ color: '#4caf50', marginRight: '8px' }} />
                        {item}
                    </li>
                ))}
            </ul>
        </div>
        <div className="">
            <Typography.Title level={4}>Skills you'll gain</Typography.Title >
            <div className="flex gap-4 flex-wrap">
                {tags.map(tag =>
                    <Badge count={tag} key={tag} color="royalblue" />
                )}
            </div>
        </div>
        <div className="">
            <Typography.Title level={4}>Details to know</Typography.Title >
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <div
                    className="p-4 rounded-lg shadow-sm bg-white"
                >
                    <FileProtectOutlined className='text-3xl text-blue-600' />
                    <Typography.Title level={5} className="!mb-0 mt-2">
                        Shareable Certificate
                    </Typography.Title>
                    <Typography.Text className="text-gray-600">
                        Add to your LinkedIn profile
                    </Typography.Text>
                </div>
                <div
                    className="p-4 rounded-lg shadow-sm bg-white"
                >
                    <BookOutlined
                        className='text-3xl text-blue-600' />
                    <Typography.Title level={5} className="!mb-0 mt-2">
                        Assessments
                    </Typography.Title>
                    <Typography.Text className="text-gray-600">
                        21 assignments
                    </Typography.Text>
                </div>
            </div>
        </div>
    </div>

    );
};

export default AboutTab

